import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18next from 'i18next';

import * as CustomPropTypes from 'lib/CustomPropTypes';
import { vertical as verticalContext } from 'lib/ContextTypes';
import { formatDuration } from 'lib/DateTime';
import { imageAltForImage } from 'lib/imageAlt';
import Breakpoints from 'lib/Breakpoints';
import AIMS_FLAVORS from 'lib/aimsFlavors';
import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';
import { REMOVE_NOW_PLAYING_VIDEO_FROM_PLAYLIST } from 'lib/brandFeatures.json';

import LazyLoad from 'components/LazyLoad';
import Picture from 'components/Picture';

class Video extends React.Component {
  static contextType = verticalContext;

  static propTypes = {
    video: CustomPropTypes.video.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    playlistIndex: PropTypes.number,
    playlist: CustomPropTypes.videoPlaylist,
    upNext: PropTypes.bool,
    vilynxEnabled: PropTypes.bool,
  };

  static defaultProps = {
    selected: false,
    onClick: Function.prototype,
    playlistIndex: 0,
    playlist: {},
    upNext: false,
    vilynxEnabled: true,
  };

  clickHandler = (event) => {
    event.preventDefault();
    const {
      video, onClick, playlistIndex, playlist,
    } = this.props;
    onClick(video, playlistIndex, playlist);
    window.scrollTo(0, 0);
  }

  render() {
    const vertical = this.context;
    const {
      video, selected, upNext, playlistIndex, vilynxEnabled,
    } = this.props;
    const {
      url: { primary: url }, primaryImage, duration, headline,
    } = video;

    const vilynxSettings = vilynxEnabled ? {
      'data-vilynx-id': url,
      'data-vilynx-redirect': '',
      'data-vilynx-redirectwithclick': '',
    } : {};

    if (getFeatureConfigForBrand(REMOVE_NOW_PLAYING_VIDEO_FROM_PLAYLIST, vertical) && selected) {
      return null;
    }

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <LazyLoad
        overflow={!Breakpoints.isSorM() && playlistIndex > 6}
        placeholder={false}
      >
        <div
          className={classNames(
            'playlist-drawer__video',
            { vilynx_enabled: vilynxEnabled },
            { 'playlist-drawer__up-next': upNext },
          )}
          data-active-text={i18next.t('UP NEXT')}
          onClick={this.clickHandler}
          {...vilynxSettings}
        >
          <div
            className={classNames('playlist-drawer__thumbnail', { 'playlist-drawer__active': selected })}
            data-active-text={i18next.t('Now Playing')}
          >
            <Picture
              url={primaryImage.url.primary}
              className={classNames('playlist-drawer__thumbnail')}
              responsiveFlavors={{
                s: AIMS_FLAVORS.FOCAL_520x260,
                m: AIMS_FLAVORS.FOCAL_760x380,
                l: AIMS_FLAVORS.FOCAL_280x140,
              }}
              alt={imageAltForImage(primaryImage)}
              preview={false}
            />
          </div>
          <div className={classNames('playlist-drawer__info', 'pl4-l pr6-l pa5-l')}>
            <h2 className={classNames('playlist-drawer__title')}>
              {headline.tease}
            </h2>
            <span className={classNames('playlist-drawer__duration', 'founders-mono')}>
              {formatDuration(duration)}
            </span>
          </div>
        </div>
      </LazyLoad>
    );
    /* eslint-enable jsx-a11y/click-events-have-key-events */
    /* eslint-enable jsx-a11y/no-static-element-interactions */
  }
}

export default Video;
